jQuery( document ).ready(function() {

  var isotopeScript = document.createElement('script');
  isotopeScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/jquery.isotope/3.0.6/isotope.pkgd.min.js');
  isotopeScript.onload = function() {
  
    var $grid = jQuery('.product-list').isotope({
    itemSelector: '.product-item',
    layoutMode: 'fitRows',
    transitionDuration: '0s'
    });
  
    // Variables for pagination
    if(jQuery(window).width() > 767) {
      var itemsPerPage = 15;
    }
    else {
      var itemsPerPage = 8;
    }
    var currentPage = 1;
    var filters = [];
    var qsRegex;
  
    function filterAndPaginate() {
      var $filteredItems = $grid.isotope('getFilteredItemElements');
      var totalPages = Math.ceil($filteredItems.length / itemsPerPage);
  
      if (currentPage > totalPages) {
        currentPage = totalPages;
      }
      if (currentPage < 1) {
        currentPage = 1;
      }
  
      var start = (currentPage - 1) * itemsPerPage;
      var end = start + itemsPerPage;
  
      $grid.isotope({
        filter: function() {
          var filterResult = filters.length ? $(this).is(filters.join(',')) : true;
          return filterResult;
        }
      });
  
      $filteredItems = $grid.isotope('getFilteredItemElements');
      jQuery($filteredItems).hide().slice(start, end).show();
      $grid.isotope('layout');
      updateButtons(totalPages);
      updatePageNumbers(totalPages);
      // updateActiveItemCount($filteredItems.slice(start, end).length); // Update active item count
    }
  
  
    // function updateActiveItemCount(count) {
    //   $('#active-item-count').text(count);
    // }
  
    function updateButtons(totalPages) {
      jQuery('#prev').prop('disabled', currentPage <= 1);
      jQuery('#next').prop('disabled', currentPage >= totalPages);
    }
  
    function updatePageNumbers(totalPages) {
      var $pageNumbers = jQuery('#page-numbers');
      $pageNumbers.empty();
      for (var i = 1; i <= totalPages; i++) {
        var $pageNumber = jQuery('<span class="page-number"></span>');
        $pageNumber.text(i);
        if (i === currentPage) {
          $pageNumber.addClass('active');
        }
        $pageNumber.click(function() {
          currentPage = parseInt(jQuery(this).text());
          filterAndPaginate();
        });
        $pageNumbers.append($pageNumber);
      }
    }
  
    jQuery('#prev').click(function() {
      currentPage--;
      filterAndPaginate();
    });
  
    jQuery('#next').click(function() {
      currentPage++;
      filterAndPaginate();
    });
  
    // Filter items on button click
    jQuery('.side-nav-bar').on('click', '.tag-data', function() {
      console.log('tag click event');
      var filterValue = $(this).attr('data-filter');
      $(this).toggleClass('active');
      if ($(this).hasClass('active')) {
        filters.push(filterValue);
      } else {
        filters = filters.filter(function(value) {
          return value !== filterValue;
        });
      }
      currentPage = 1; // Reset to the first page when filter changes
      filterAndPaginate();
  
      setTimeout(function() {
        filterAndPaginate();
      }, 300);
    });
  
  
    $('#reset-filters').click(function() {
      filters = [];
      qsRegex = null;
      $('.filter-group button').removeClass('active');
      $('#search').val('');
      currentPage = 1; 
      filterAndPaginate();
      setTimeout(function() {
        filterAndPaginate();
      }, 300);
    });
  
    filterAndPaginate();

    /*Buyer Filter  */
    var $grid_new = jQuery('.blog-posts-list').isotope({
    itemSelector: '.blog-post',
    layoutMode: 'fitRows',
    transitionDuration: '0s'
    });
 
    // Variables for pagination
    if(jQuery(window).width() > 767) {
      var itemsPerPage = 12;
    }
    else {
      var itemsPerPage = 8;
    }
    var currentPage = 1;
    var filters = [];
    var qsRegex;
  
    function filterAndPaginatenew() {
      var $filteredItems = $grid_new.isotope('getFilteredItemElements');
      var totalPages = Math.ceil($filteredItems.length / itemsPerPage);
  
      if (currentPage > totalPages) {
        currentPage = totalPages;
      }
      if (currentPage < 1) {
        currentPage = 1;
      }
  
      var start = (currentPage - 1) * itemsPerPage;
      var end = start + itemsPerPage;
  
      $grid_new.isotope({
        filter: function() {
          // var filterResult = filters.length ? $(this).is(filters.join(',')) : true;
          var filterResult =  filters.length ? $(this).is(filters) : true;
          return filterResult;
        }
      });
  
      $filteredItems = $grid_new.isotope('getFilteredItemElements');
      jQuery($filteredItems).hide().slice(start, end).show();
      $grid_new.isotope('layout');
      updateButtons(totalPages);
      updatePageNumbers(totalPages);
      // updateActiveItemCount($filteredItems.slice(start, end).length); // Update active item count
    }
  
  
    // function updateActiveItemCount(count) {
    //   $('#active-item-count').text(count);
    // }
  
    function updateButtons(totalPages) {
      jQuery('#prev').prop('disabled', currentPage <= 1);
      jQuery('#next').prop('disabled', currentPage >= totalPages);
    }
  
    function updatePageNumbers(totalPages) {
      var $pageNumbers = jQuery('#page-numbers');
      $pageNumbers.empty();
      for (var i = 1; i <= totalPages; i++) {
        var $pageNumber = jQuery('<span class="page-number"></span>');
        $pageNumber.text(i);
        if (i === currentPage) {
          $pageNumber.addClass('active');
        }
        $pageNumber.click(function() {
          currentPage = parseInt(jQuery(this).text());
          filterAndPaginatenew();
        });
        $pageNumbers.append($pageNumber);
      }
    }
  
    jQuery('#prev').click(function() {
      currentPage--;
      filterAndPaginatenew();
    });
  
    jQuery('#next').click(function() {
      currentPage++;
      filterAndPaginatenew();
    });
  
    // Filter items on button click
   jQuery('#tag-filter-data').on('change', function() {
      var filterValue = this.value;
      jQuery(this).toggleClass('active');
       filters =  this.value;
      currentPage = 1; // Reset to the first page when filter changes
      filterAndPaginatenew();
  
      setTimeout(function() {
        filterAndPaginatenew();
      }, 300);
    });
  
  
    jQuery('#reset-filters').click(function() {
      filters = [];
      qsRegex = null;
      jQuery('#search').val('');
      currentPage = 1; 
      filterAndPaginatenew();
      setTimeout(function() {
        filterAndPaginatenew();
      }, 300);
    });
  
    filterAndPaginatenew();    
    
  };
  document.head.appendChild(isotopeScript);

    //  $('#tag-filter-data').change(function() {
    //   console.log('change filter');
    // // Get the selected value
    // var selectedValue = $(this).val();
    // console.log(selectedValue);
    // // If 'all' is selected, show all the elements
    // if (selectedValue === 'all') {
    //   $('.blog-post').show(); // Show all elements with class "content"
    // } else {
    //   // Hide all elements and then show only the selected one
    //   $('.blog-post').hide(); // Hide all elements
    //   $('.' + selectedValue).show(); // Show the selected option's content
    // }
    // });

     var batch = 5; // Number of items to show initially and per click

    // For each filter-wrap (for both .promotion and .offer)
    $(".filter-wrap").each(function() {
        var listItems = $(this).find(".tag-data");
        var loadMoreBtn = $(this).siblings("#load-more-btn");

        // Hide all items after the first batch
        listItems.each(function(index) {
            if (index >= batch) {
                $(this).fadeOut("slow").addClass("hide");
            }
        });

        // Hide "SHOW ALL" button if there are 5 or fewer items
        if (listItems.length <= batch) {
            loadMoreBtn.hide();
        }

        // Show more items when "SHOW ALL" is clicked
        loadMoreBtn.on("click", function(e) {
            e.preventDefault();

            // Show the next batch of hidden items
            $(this).siblings(".filter-wrap").find(".tag-data:hidden").slice(0, batch).fadeIn("slow");

            // If no hidden items remain, hide the button or change text
            if ($(this).siblings(".filter-wrap").find(".tag-data:hidden").length == 0) {
                $(this).text("SHOW LESS").off('click').on('click', function(e) {
                    e.preventDefault();
                    listItems.slice(batch).fadeOut("slow").addClass("hide");
                    $(this).text("SHOW ALL");
                });
            }
        });
    });

    /*Quantity selector js*/
    var minusBtn = document.querySelector('.minus-btn');
    var plusBtn = document.querySelector('.plus-btn');
    var quantityInput = document.querySelector('.quantity-input');

    // Decrease quantity
    minusBtn.addEventListener('click', function() {
      var currentValue = parseInt(quantityInput.value);
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });

    // Increase quantity
    plusBtn.addEventListener('click', function() {
      var currentValue = parseInt(quantityInput.value);
      quantityInput.value = currentValue + 1;
    });

   
  
  
});

function setEqualHeight(selector) {
  const elements = document.querySelectorAll(selector);
  let maxHeight = 0;

  // Reset the height first
  elements.forEach((element) => {
    element.style.height = 'auto';
  });

  // Find the maximum height
  elements.forEach((element) => {
    if (element.offsetHeight > maxHeight) {
      maxHeight = element.offsetHeight;
    }
  });

  // Set all elements to the maximum height
  elements.forEach((element) => {
    element.style.height = `${maxHeight}px`;
  });
}

// Call the function on page load and when the window is resized
window.addEventListener('load', function() {
  setEqualHeight('.slides-post .eq-date h3');
});

window.addEventListener('resize', function() {
  setEqualHeight('.slides-post .eq-date h3');
});

